import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const StoreFilters = ({
 selectedCategory,
 setSelectedCategory,
 selectedMachine,
 setSelectedMachine,
 showOnSale,
 setShowOnSale,
 currency,
 setCurrency,
 filteredCount,
 totalCount
}) => {
 return (
 <Card className="mb-8 shadow-lg">
 <CardHeader>
 <div className="flex items-center justify-between">
 <div>
 <CardTitle>Products & Services</CardTitle>
 <CardDescription>
 Browse accessories, templates, and professional services for your freeze-drying business
 </CardDescription>
 </div>
 {/* Currency Toggle */}
 <div className="flex gap-2">
 <Button
 variant={currency === 'CAD' ? 'default' : 'outline'}
 size="sm"
 onClick={() => setCurrency('CAD')}
 >
 🇨🇦 CAD
 </Button>
 <Button
 variant={currency === 'USD' ? 'default' : 'outline'}
 size="sm"
 onClick={() => setCurrency('USD')}
 >
 🇺🇸 USD
 </Button>
 </div>
 </div>
 </CardHeader>
 <CardContent>
 {/* Filters */}
 <div className="space-y-4">
 <div className="flex flex-wrap gap-4">
 {/* Category Filter */}
 <div className="flex-1 min-w-[200px]">
 <label className="block text-sm font-medium mb-2">Category</label>
 <select 
 value={selectedCategory}
 onChange={(e) => setSelectedCategory(e.target.value)}
 className="w-full p-2 border rounded-lg bg-white dark:bg-slate-800"
 >
 <option value="All">All Categories</option>
 <option value="Accessories">Accessories</option>
 <option value="Equipment">Equipment</option>
 <option value="Supports">Supports</option>
 </select>
 </div>
 
 {/* Machine Filter */}
 <div className="flex-1 min-w-[200px]">
 <label className="block text-sm font-medium mb-2">Machine</label>
 <select 
 value={selectedMachine}
 onChange={(e) => setSelectedMachine(e.target.value)}
 className="w-full p-2 border rounded-lg bg-white dark:bg-slate-800"
 >
 <option value="All">All Machines</option>
 <option value="Small Freeze Dryer">Small Freeze Dryer</option>
 <option value="Medium Freeze Dryer">Medium Freeze Dryer</option>
 <option value="Large Freeze Dryer">Large Freeze Dryer</option>
 <option value="Commercial Freeze Dryer">Commercial Freeze Dryer</option>
 <option value="Industrial Freeze Dryer">Industrial Freeze Dryer</option>
 <option value="Other">Other</option>
 </select>
 </div>
 </div>
 
 {/* On Sale Toggle */}
 <div className="flex items-center gap-2 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
 <input
 type="checkbox"
 id="show_on_sale"
 checked={showOnSale}
 onChange={(e) => setShowOnSale(e.target.checked)}
 className="w-4 h-4"
 />
 <label htmlFor="show_on_sale" className="cursor-pointer font-medium">
 🏷️ Show only items on sale
 </label>
 </div>
 
 {/* Result Count */}
 <p className="text-sm text-slate-600 dark:text-neutral-400">
 Showing {filteredCount} of {totalCount} products
 {showOnSale && ` • ${filteredCount} on sale`}
 </p>
 </div>
 </CardContent>
 </Card>
 );
};

export default StoreFilters;
